import { render, staticRenderFns } from "./UserBoardStepDetail.vue?vue&type=template&id=c85d9e32&scoped=true&"
import script from "./UserBoardStepDetail.vue?vue&type=script&lang=js&"
export * from "./UserBoardStepDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserBoardStepDetail.vue?vue&type=style&index=0&id=c85d9e32&lang=scss&scoped=true&"
import style1 from "./UserBoardStepDetail.vue?vue&type=style&index=1&id=c85d9e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85d9e32",
  null
  
)

export default component.exports